export const authFormConfig = {
  createAccount: {
    heading: "Create your Buoy account",
    buttonText: "Create account",
    mainText:
      "Your Buoy account brings your benefits together and allows you to customize your experience.",
    checkList: [
      "View and access your employee benefits",
      "Smarter, faster assessments with saved medical history",
      "Personalized care recommendations",
    ],
  },
  login: {
    heading: "Log in to your account",
    buttonText: "Log in",
    links: [
      {
        text: "Forgot password?",
        path: "/reset/",
      },
    ],
  },
}



// WEBPACK FOOTER //
// ./assets/dashboard/components/authFormConfig.js